import { useContext } from 'react';

import {
  Tabs,
  TabsProps,
  Theme,
  createStyles,
  withStyles,
} from '@material-ui/core';

import { ActivityItemContext } from './ActivityItemContext';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      minHeight: theme.spacing(3),
      marginBottom: theme.spacing(1),
    },
    indicator: {
      // OCD
      height: '1.25px',
    },
  });

export interface ActivityItemTabsProps extends TabsProps {}

const ActivityItemTabs = (props: ActivityItemTabsProps) => {
  const { tab, setTab } = useContext(ActivityItemContext);
  return (
    <Tabs
      {...props}
      value={tab}
      onChange={(_event, value) => setTab?.(value)}
    />
  );
};

export default withStyles(styles)(ActivityItemTabs);
